import { render, staticRenderFns } from "./ModalTransfer.vue?vue&type=template&id=b6d46ad0&lang=pug&"
import script from "./ModalTransfer.vue?vue&type=script&lang=js&"
export * from "./ModalTransfer.vue?vue&type=script&lang=js&"
import style0 from "./ModalTransfer.vue?vue&type=style&index=0&id=b6d46ad0&prod&lang=sass&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports